import { createFileRoute } from '@tanstack/react-router'
import { LegacyMatchAliasRecovery } from '~/features/football-match-detail/football-match-detail'
import { loadLegacyMatchAliasRoute } from '~/features/football-match-detail/legacy-route-options'
import { handleLegacyMatchAliasRequest } from '~/features/football-match-detail/legacy-server-handler'

export const Route = createFileRoute('/$locale/research/matches/$matchId')({
  server: {
    handlers: {
      GET: ({ request, params }) => handleLegacyMatchAliasRequest({
        request,
        sourceKind: 'research_match',
        sourceId: params.matchId,
        locale: params.locale === 'zh-CN' ? 'zh-CN' : 'en',
      }),
    },
  },
  loader: ({ params, location }) => loadLegacyMatchAliasRoute({
    sourceKind: 'research_match',
    sourceId: params.matchId,
    locale: params.locale === 'zh-CN' ? 'zh-CN' : 'en',
    location,
  }),
  component: LocalizedResearchMatchLegacyRoute,
  notFoundComponent: () => <LegacyMatchAliasRecovery locale="zh-CN" kind="not_found" />,
})

function LocalizedResearchMatchLegacyRoute() {
  const { locale } = Route.useParams()
  const state = Route.useLoaderData()
  return (
    <LegacyMatchAliasRecovery
      locale={locale === 'zh-CN' ? 'zh-CN' : 'en'}
      kind={state.kind}
    />
  )
}
